import { render, staticRenderFns } from "./PaymentAddressTab.vue?vue&type=template&id=55cc4bfd"
import script from "./PaymentAddressTab.vue?vue&type=script&lang=js"
export * from "./PaymentAddressTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports